let sliderExists = false;
// const arrowShape = 'm71.345 98.711c-.765 0-1.466-.319-2.041-.829l-45.901-45.901c-1.147-1.147-1.147-2.932 0-4.016l45.901-45.901c1.148-1.084 2.997-1.02 4.081.127 1.02 1.083 1.02 2.805 0 3.889l-43.925 43.861 43.861 43.861c1.147 1.147 1.147 2.933 0 4.08-.51.51-1.211.829-1.976.829z';
const arrowShape = 'M62.26,15.12,30.65,46.26a4.89,4.89,0,0,0,.19,7.15L62.73,85s3,2.63,6.21-1.13S70.26,78,70.26,78L44.37,51.55l-.32-.34a2,2,0,0,1,0-2.75h0L70,22.27s2.44-2.63-1.13-6.3S62.26,15.12,62.26,15.12Z';
const sliderBreakpoint = 768;
const sliderSettings = {
  'arrowShape': arrowShape,
  'pageDots': false,
  'imagesLoaded': true,
  'wrapAround': true,
};

let windowWidth = jQuery(window).width();

const createSlideshow = function() {
  jQuery('.gallery-large').flickity(sliderSettings);
};

const destroySlideshow = function() {
  jQuery('.gallery-large').flickity('destroy');
};

let toggleSlideshow = function() {
  if (windowWidth >= sliderBreakpoint && sliderExists == false) {
    createSlideshow();
    sliderExists = true;
  } else if (windowWidth < sliderBreakpoint && sliderExists) {
    destroySlideshow();
    sliderExists = false;
  }
};

// Initial load to create slideshow
toggleSlideshow();

(function() {

  window.addEventListener('resize', resizeThrottler, false);

  var resizeTimeout;
  function resizeThrottler() {
    if (!resizeTimeout) {
      resizeTimeout = setTimeout(function() {
        resizeTimeout = null;
        actualResizeHandler();
       }, 66);
    }
  }

  function actualResizeHandler() {
    windowWidth = jQuery(window).width();
    toggleSlideshow();
  }

}());

const sliderSettingsFeed = {
  'align-items': 'left',
  arrowShape: arrowShape,
  pageDots: false,
  imagesLoaded: true,
  wrapAround: true,
  cellSelector: '.carousel-cell',
  watchCSS: true,
  draggable: true,
  // "groupCells": 2,
};

jQuery('.just-announced-shows-feed .events-feed').flickity(sliderSettingsFeed);

// Slideshow functionality for Images and Content pages
const imagesSide = document.querySelector('.images-side');
let imagesSlideShow;

if (imagesSide) {
  imagesSlideShow = new Flickity(imagesSide, {
    // options
    cellAlign: 'center',
    contain: true,
    pageDots: false,
    watchCSS: true,
    wrapAround: true,
    cellSelector: '.image-slide',
    prevNextButtons: false,
  });

  updateStatus();
  imagesSlideShow.on('change', updateStatus);

  const slideShowControls = document.querySelector('[data-slideshow-controls]');

  slideShowControls.addEventListener('click', (event) => {
    const controlDataAttribute = 'data-slide-action';
    const target = event.target;
    let control;

    if (target.hasAttribute(controlDataAttribute)) {
      control = target;
    }

    if (target.closest('button').hasAttribute(controlDataAttribute)) {
      control = target.closest('button');
    }

    if (control) {
      const action = control.getAttribute(controlDataAttribute);

      if (action === 'next') {
        imagesSlideShow.next();
      }
      if (action === 'previous') {
        imagesSlideShow.previous();
      }
    }
  });
}

function updateStatus() {
  if (!imagesSlideShow || !imagesSlideShow.slides || imagesSlideShow.slides.length <= 1) { return; }

  const slideShowStatus = document.querySelector('[data-slideshow-status]');
  const cellNumber = imagesSlideShow.selectedIndex + 1;

  slideShowStatus.textContent = cellNumber + '/' + imagesSlideShow.slides.length;
}

const eventSliders = document.querySelectorAll('.slideshow--events');
const eventSliderOptions = {
  // options
  cellSelector: '.slide',
  cellAlign: 'center',
  wrapAround: true,
  imagesLoaded: true,
  pageDots: false,
  // contain: true
};

// enable prev/next buttons at 768px
// if (matchMedia('screen and (min-width: 1024px)').matches) {
// }
eventSliderOptions.cellAlign = 'left';

eventSliders.forEach((slider) => {
  new Flickity(slider, eventSliderOptions);
});


const carousels = document.querySelectorAll('.carousel-cards');
const carouselOptions = {
  // options
  cellSelector: '.card',
  cellAlign: 'left',
  wrapAround: true,
  imagesLoaded: true,
  pageDots: true,
  arrowShape: arrowShape,
  // contain: true
};

carousels.forEach((carousel) => {
  new Flickity(carousel, carouselOptions);
});


// const eventCalendarSliders = document.querySelectorAll('.venue-calendar-slideshow-wrapper .slideshow--venue');
// const eventCalendarSliderOptions = {
//   // options
//   cellSelector: '.slide',
//   cellAlign: 'center',
//   wrapAround: true,
//   imagesLoaded: true,
//   pageDots: false,
//   // contain: true
// };
//
// eventCalendarSliders.forEach((slider) => {
//   new Flickity(slider, eventCalendarSliderOptions);
// });
